import React from "react";
import styled from "styled-components";
import CenteredSpinner from "./centered-spinner";
import PropTypes from "prop-types";

const SpinnerContainer = styled.div`
  ${props =>
    props.height ? `min-height: ${props.height}px` : `min-height: 300px`};
  width: 100%;
  display: flex;
  align-items: center;
`;

function RenderPropSpinner({ loading, component, height }) {
  if (loading) {
    return (
      <SpinnerContainer height={height}>
        <CenteredSpinner />
      </SpinnerContainer>
    );
  }

  return component();
}

export default RenderPropSpinner;

RenderPropSpinner.propTypes = {
  component: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  height: PropTypes.number
};
